import React from "react";
import { createRoot } from "react-dom/client";
import { MessageArea } from "../components/filtering/MessageArea";
import { BreadCrumbsContainer } from "../components/filtering/BreadCrumbsContainer";
import { FilterFetch } from "./FilterFetch";
import { AjaxClient } from "../AjaxClient";
import { BreadCrumb } from "../components/filtering/BreadCrumb";
import { SubFilter } from "../components/filtering/SubFilter";
import { Paginator, ResultCount } from "../components/filtering/Paginator";
import { parseSearch, updateHistory } from "./history";
import { LoadingSpinner } from "../components/filtering/LoadingSpinner";
import { SearchForm, UseSearch } from "../components/filtering/TextSearch";
const AJAX_ENDPOINT = "/case-studies/grid-layout";
// Industry == Legal | Medical | Regulatory etc.
const INDUSTRIES_CRAFT_HANDLE = "caseStudyIndustries";
// Service == Executive Consulting | Strategic Consulting | Computer Software, etc.
const SERVICES_CRAFT_HANDLE = "caseStudyServices";
// Technology == React | Python | AWS etc.
const TECHNOLOGY_CRAFT_HANDLE = "caseStudyTechnology";
function prepState(objects, hierarchy, // which dropdown it belongs to
tagIds = []) {
    return objects.map(x => {
        return {
            active: tagIds.indexOf(x.term_id) >= 0 ? true : false,
            termId: x.term_id,
            name: x.name,
            hierarchy
        };
    });
}
function CaseStudiesFilterBar(props) {
    const breadcrumbs = [
        ...props.industry,
        ...props.services,
        ...props.technology
    ].map(x => (React.createElement(BreadCrumb, { key: `${x.termId}-${x.name}`, termId: x.termId, name: x.name, active: x.active, handleClick: props.updateTerm, hierarchy: x.hierarchy })));
    const subfilterProps = [
        { label: "INDUSTRY", data: props.industry, hierarchy: "industry" },
        {
            label: "SERVICES",
            data: props.services,
            hierarchy: "services"
        },
        {
            label: "TECHNOLOGY",
            data: props.technology,
            hierarchy: "technology"
        }
    ];
    const subFilters = subfilterProps.map(x => (React.createElement(SubFilter, { key: x.label, label: x.label, data: x.data, hierarchy: x.hierarchy, handleClick: props.updateTerm, clearDropdownHandler: props.clearDropdown, color: props.filterColor })));
    subFilters.push(React.createElement(UseSearch, { key: "useSearch", onClick: props.openSearch, filterColor: props.filterColor, target: "case-studies-section" }));
    return (React.createElement("div", { id: "case-studies-filter-bar", className: "case-studies-filter-bar flex flex-col md:flex-row flex-wrap md:items-center relative col-span-5 gap-2  "
            + (props.filterColor === "white" ? "border-white" : "border-black") }, props.showSearch ? React.createElement(SearchForm, { closeSearch: props.closeSearch, updateQuery: props.updateQuery, query: props.query, filterColor: props.filterColor, backToLabel: "Back To Case Studies", target: "case-studies-section" }) : subFilters));
}
export class CaseStudiesIndex extends React.Component {
    constructor(props) {
        super(props);
        this.blogLayoutRef = React.createRef();
        this.initialState = {
            industry: prepState(this.props.industryData, "industry", this.props.qParams.industry),
            services: prepState(this.props.servicesData, "services", this.props.qParams.services),
            technology: prepState(this.props.technologyData, "technology", this.props.qParams.technology),
            pagination: this.props.paginationInit,
            page: this.props.qParams.page,
            pending: false,
            showSearch: this.props.qParams.query.length > 0 ? true : false,
            query: this.props.qParams.query,
            markup: this.props.initialMarkup,
            filterFetch: this.props.filterFetch
        };
        this.state = Object.assign({}, this.initialState);
        this.updateSingleTag = this.updateSingleTag.bind(this);
        this.clearDropdown = this.clearDropdown.bind(this);
        this.fetchFilteredPosts = this.fetchFilteredPosts.bind(this);
        this.loadPage = this.loadPage.bind(this);
        this.openSearch = this.openSearch.bind(this);
        this.closeSearch = this.closeSearch.bind(this);
        this.updateQuery = this.updateQuery.bind(this);
    }
    updateSingleTag(termId, active, hierarchy) {
        const newState = Object.assign({}, this.state);
        if (hierarchy in newState) {
            newState[hierarchy] = newState[hierarchy].map((x) => {
                if (x.termId === termId) {
                    return Object.assign(Object.assign({}, x), { active: !x.active });
                }
                else {
                    return x;
                }
            });
            this.setState(newState);
        }
    }
    updateShowSearch(showSearch) {
        const newState = Object.assign({}, this.state);
        newState.showSearch = showSearch;
        newState.query = "";
        newState.page = 1;
        this.setState(newState);
    }
    openSearch() {
        this.updateShowSearch(true);
    }
    closeSearch() {
        this.updateShowSearch(false);
    }
    updateQuery(q) {
        const newState = Object.assign({}, this.state);
        newState.query = q;
        newState.page = 1;
        this.setState(newState);
    }
    clearDropdown(hierarchy) {
        const newState = Object.assign({}, this.state);
        newState[hierarchy] = this.initialState[hierarchy];
        this.setState(newState);
    }
    buildFilters(filter, selection) {
        const activeSelection = selection
            .filter(x => x.active)
            .map(x => x.termId);
        return { group: filter, ids: activeSelection };
    }
    fetchFilteredPosts(page = 1, options = { method: "overwrite" }) {
        this.setState(Object.assign(Object.assign({}, this.state), { pending: true }));
        const historyState = {
            industry: this.state.industry,
            services: this.state.services,
            technology: this.state.technology,
            page,
            query: this.state.query
        };
        this.state.filterFetch.fetchPosts(historyState, AJAX_ENDPOINT)
            .then((response) => {
            const newState = Object.assign({}, this.state);
            const blogWrapper = this.blogLayoutRef.current;
            if (blogWrapper) {
                const markup = response.markup ? response.markup : "";
                if (options.method === "overwrite") {
                    newState.markup = markup;
                }
                else {
                    newState.markup = this.state.markup + markup;
                }
                newState.pending = false;
            }
            newState.pagination.totalPages = response.pages;
            newState.pagination.entryTotal = response.total;
            newState.pagination.first = response.first;
            newState.pagination.last = response.last;
            this.setState(newState);
        })
            .catch(error => console.error(error));
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(this.state.services === prevState.services &&
            this.state.technology === prevState.technology &&
            this.state.industry === prevState.industry &&
            this.state.query === prevState.query)) {
            this.fetchFilteredPosts();
            const historyState = {
                industry: this.state.industry,
                services: this.state.services,
                technology: this.state.technology,
                page: this.state.page,
                query: this.state.query
            };
            updateHistory(historyState);
            this.scrollIntoResults();
        }
        // if page number changes
        else if (!(this.state.page === prevState.page)) {
            this.fetchFilteredPosts(this.state.page);
            const historyState = {
                category: this.state.category,
                postType: this.state.postType,
                postTag: this.state.postTag,
                page: this.state.page,
                query: this.state.query
            };
            updateHistory(historyState);
        }
    }
    loadPage(pageNumber) {
        const newState = Object.assign({}, this.state);
        newState.page = pageNumber;
        this.setState(newState);
        // scroll to top of component
        this.scrollIntoResults();
    }
    scrollIntoResults() {
        const top = document.getElementById('case-studies-section');
        if (!top)
            return;
        top.scrollIntoView({
            behavior: "smooth"
        });
    }
    render() {
        const loadingStyles = this.state.pending ? " opacity-20" : "";
        const breadcrumbs = [
            ...this.state.industry,
            ...this.state.services,
            ...this.state.technology
        ].map(x => (React.createElement(BreadCrumb, { key: `${x.termId}-${x.name}`, termId: x.termId, name: x.name, active: x.active, handleClick: this.updateSingleTag, hierarchy: x.hierarchy })));
        return (React.createElement("div", null,
            React.createElement("div", { className: "relative md:flex justify-between items-center " },
                React.createElement(CaseStudiesFilterBar, { filterColor: this.props.filterColor, industry: this.state.industry.map(item => (Object.assign(Object.assign({}, item), { name: item.name.replace(/&amp;/g, "&") }))), services: this.state.services.map(item => (Object.assign(Object.assign({}, item), { name: item.name.replace(/&amp;/g, "&") }))), technology: this.state.technology, updateTerm: this.updateSingleTag, clearDropdown: this.clearDropdown, postCount: this.state.postCount, pending: this.state.pending, showSearch: this.state.showSearch, openSearch: this.openSearch, closeSearch: this.closeSearch, updateQuery: this.updateQuery, query: this.state.query }),
                React.createElement(MessageArea, { pending: this.state.pending, postCount: this.state.postCount }),
                React.createElement(Paginator, { pagination: this.state.pagination, page: this.state.page, updatePage: this.loadPage })),
            React.createElement(BreadCrumbsContainer, { breadcrumbs: breadcrumbs, className: "border-white border-bottom pb-7 mb-20 mt-3" }),
            React.createElement("div", { className: `case-studies-grid` + loadingStyles, ref: this.blogLayoutRef, dangerouslySetInnerHTML: { __html: this.state.markup } }),
            this.state.pending ?
                React.createElement(LoadingSpinner, null)
                :
                    React.createElement("div", { className: "border-t border-gray-350 mt-8 pt-8 md:flex justify-between" },
                        React.createElement(ResultCount, { className: "hidden md:block", pagination: this.state.pagination, page: this.state.page, updatePage: this.loadPage }),
                        React.createElement(Paginator, { pagination: this.state.pagination, page: this.state.page, updatePage: this.loadPage }))));
    }
}
export function onDOMLoaded() {
    const blogRoot = document.getElementById("case-studies-filterable-area-js");
    const blogWrapper = document.getElementById("case-studies-wrapper");
    // @ts-ignore
    let data = window.insights;
    if (blogRoot && blogWrapper && data) {
        // get URL and see if there are any query params
        const qParams = parseSearch(document.location.search);
        const initialMarkup = blogWrapper.innerHTML;
        const postCount = blogWrapper.childElementCount;
        const { color: filterColor, case_study_services: servicesData, case_study_technology: technologyData, case_study_industry: industryData } = data.filters;
        const root = createRoot(blogRoot);
        root.render(React.createElement(CaseStudiesIndex, { filterColor: filterColor, servicesData: servicesData, technologyData: technologyData, industryData: industryData, initialMarkup: initialMarkup, filterFetch: new FilterFetch(new AjaxClient()), qParams: qParams, 
            // @ts-ignore paginationInit pulled from template
            paginationInit: paginationInit }));
    }
}
